<div class="notifications">
    <div class="notification {{cssClass(item)}}" [@enterLeave]="'flyIn'" *ngFor="let item of notifications">
        <div class="notification__close" *ngIf="showCloseButton">
            <app-button
                    [cssClasses]="'icon wh-32'"
                    [disabled]="false"
                    [icon]="'close'"
                    [iconColor]="'gray-08'"
                    (buttonClicked)="removeNotification(item)">
            </app-button>
        </div>
        <mat-icon class="notification__icon material-icons-round">{{item.icon}}</mat-icon>
        <div class="notification__content">{{item.message}}</div>
    </div>
</div>